/* angular:styles/component:css;628e56ca04d4141ce237089e69966d220156efd0fe8bc0beea6d965ce706510a;/Users/daniyal/Cuboid AS Dropbox/Daniyal Ahmed/Development/friggkantine-admin/projects/portal/src/app/core/confirm-dialog.component.ts */
.confirm-message {
  font-size: 14px;
  color: #46617a;
  line-height: 1.5;
  margin: 0;
}
/*# sourceMappingURL=confirm-dialog.component.css.map */
